import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title (t \"pages.shipments.title\")}}\n\n{{outlet}}",{ moduleName: "walden-trace-app/templates/app/shipments.hbs" })